import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage
import userReducer from './slices/userSlice';
import subscriptionReducer from './slices/subscriptionSlice';

// Persist configuration
const persistConfig = {
   key: 'root',
   storage,
   whitelist: ['user', 'subscription'], // Persist user and subscription slices
   version: 1,
};

// Root reducer
const rootReducer = combineReducers({
   user: userReducer,
   subscription: subscriptionReducer,
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
export const store = configureStore({
   reducer: persistedReducer,
   devTools: process.env.NODE_ENV !== 'production',
});

// Create persistor
export const persistor = persistStore(store);

// Export types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
